function t(e) {
  if (typeof window > "u") return;
  const a = window;
  a.dataLayer = a.dataLayer || [], a.dataLayer.push({ event: "new_chat_click", source: e });
}
export {
  t as trackNewChatClick
};
